import { createContext } from 'utils/react-helpers';

const [VehicleProvider, useVehicle] = createContext({ name: 'VehicleContext' });

export { VehicleProvider, useVehicle };
